import { render, staticRenderFns } from "./viewCurrentMemberDetails.vue?vue&type=template&id=09c63b8d"
import script from "./viewCurrentMemberDetails.vue?vue&type=script&lang=js"
export * from "./viewCurrentMemberDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports